import {
	makeStyles,
	shorthands,
	tokens
} from "@fluentui/react-components";

export const useStyle = makeStyles({
	searchInput: {
		...shorthands.border("none"),
        backgroundColor: tokens.colorNeutralBackground1Hover
    },
	popoverSurface: {
		...shorthands.padding(0)
	},
	listItem: {
		backgroundColor: tokens.colorNeutralBackground1,
		">div:first-child >span:first-child":{
			width:"0px !important",
			height:"0px !important"
		}
	},
	listContainer: {
		width: "300px",
	},
});